import React from "react";
import themes from "./themes";
import ThemeContext from "./ThemeContext";

const Theme = ({ children = null, value }) => (
  <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>
);

export { Theme as default, themes, ThemeContext };
